import React from 'react';

import Icon from '../../Icon';
import { tableEmptyStateVariants } from './tableStyles';

type TableEmptyStateProps = {
  columnsCount: number;
  children: React.ReactNode;
};

const TableEmptyState: React.FC<TableEmptyStateProps> = ({
  columnsCount,
  children,
}) => {
  const styles = tableEmptyStateVariants();

  return (
    <tbody>
      <tr>
        <td colSpan={columnsCount} className={styles.cell()}>
          <div className={styles.content()}>
            <div className={styles.icon()}>
              <Icon icon="list" />
            </div>
            <div className={styles.title()}>{children}</div>
          </div>
        </td>
      </tr>
    </tbody>
  );
};

export default React.memo(TableEmptyState);
